import callAPI from "../callApi";
import path from "../variables";

const base = `${path.base}/accounting/bank-deposits`;

const BankDeposits = {
	getAll: (filter?: string) =>
		callAPI("GET", `${base}${filter || ""}`, "", "getting bank deposits"),
	// Montant suggéré (calculé en temps réel depuis les données du jour) +
	// config banque auto-remplie. filter = `?station=<uuid>&date=YYYY-MM-DD`.
	suggestion: (filter: string) =>
		callAPI("GET", `${base}/suggestion${filter || ""}`, "", "getting deposit suggestion", {
			skipCache: true,
		}),
	// Ajuste le montant d'un versement non vérifié (commentaire obligatoire).
	adjust: (uuid: string, data: { amount: number; comment: string }) =>
		callAPI("POST", `${base}/${uuid}/adjust`, data, "adjusting bank deposit"),
	// Rapport encaissé vs versé par agence (admin). filter = `?from=&to=`.
	report: (filter?: string) =>
		callAPI("GET", `${base}/report${filter || ""}`, "", "getting bank deposit report", { skipCache: true }),
	// data = FormData (montant, banque, date, justificatifs[]) → upload multipart.
	create: (data: FormData, config?: any) =>
		callAPI("UPLOAD", base, data, "declaring bank deposit", config),
	show: (uuid: string) =>
		callAPI("GET", `${base}/${uuid}`, "", "getting bank deposit"),
	// Justificatif servi par un endpoint authentifié (disque privé) → on le
	// récupère en blob (le bearer token voyage dans les headers axios, pas
	// dans une ouverture d'onglet directe).
	document: (uuid: string, index: number) =>
		callAPI("GET", `${base}/${uuid}/documents/${index}`, "", "getting deposit document", {
			responseType: "blob",
			skipCache: true,
		}),
	verify: (uuid: string) =>
		callAPI("POST", `${base}/${uuid}/verify`, "", "verifying bank deposit"),
	remove: (uuid: string) =>
		callAPI("DELETE", `${base}/${uuid}`, "", "deleting bank deposit"),
};

export default BankDeposits;
